const getYearFromInternationalDate = (
  internationlDateSting: string
): number => {
  return Number(internationlDateSting.substring(0, 4))
}

const convertMonthToIndex = (month: number): number => month - 1

const getMonthIndexFromInternationalDate = (
  internationalDateString: string
): number => {
  const month = Number(internationalDateString.substring(5, 7))
  const monthIndex = convertMonthToIndex(month)

  return monthIndex
}

const getDayFromInternationalDate = (
  internationalDateString: string
): number => {
  return Number(internationalDateString.substring(8, 10))
}

export const getDateArgsFromIso8601String = (
  internationlDateSting: string
): [number, number, number] => {
  const year = getYearFromInternationalDate(internationlDateSting)
  const monthIndex = getMonthIndexFromInternationalDate(internationlDateSting)
  const day = getDayFromInternationalDate(internationlDateSting)

  return [year, monthIndex, day]
}
